
// document.addEventListener('DOMContentLoaded', function () {
//   setTimeout(() => {
//     const form = document.querySelector('form[action="/cart/add"]');
//     const addToCartBtn = document.querySelector('.product-form__submit');

//     if (!form || !addToCartBtn) return;

//     console.log("✅ Form and Add to Cart button found");

//     addToCartBtn.addEventListener('click', function (e) {
//       const formData = new FormData(form);
//     const data = {};

//     data.id = formData.get('id');
//     data.variant_id = data.id; // Shopify uses same ID for variant
//     data.quantity = formData.get('quantity') || 1;

//     // Extract line item properties if any
//     data.properties = {};
//     for (const [key, value] of formData.entries()) {
//       if (key.startsWith('properties[')) {
//         const propKey = key.replace(/^properties\[|\]$/g, '');
//         data.properties[propKey] = value;
//       }
//     }

//     console.log("✅ Dynamic product data:", data);

//       fetch('/cart/add', {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json'
//         },
//         body: formData
//       })
//       .then(async response => {
//         const data = await response.json();

//         if (!response.ok) {
//           console.error("❌ Error Status:", response.status);
//           console.error("❌ Message:", data.message);
//           return;
//         }

//         console.log("🛒 Product added to cart1:", data);
//         // Optionally show confirmation or update cart drawer
//       })
//       .catch(error => {
//         console.error("❌ Network or JS error:", error);
//       });
//     });
//   }, 500);
// });












/* Validation for thr cart qunantity for single product page */
document.addEventListener("DOMContentLoaded", function () {
    const quantityInputs = document.querySelectorAll("input[type='number'][name='quantity']");

    quantityInputs.forEach(input => {
        input.addEventListener("input", function (event) {
            let value = this.value;

            // Remove any non-numeric characters (except numbers)
            value = value.replace(/[^0-9]/g, "");

            // Prevent leading zeros (turns "09" into "9")
            value = value.replace(/^0+/, "");

            // If empty, set to 1
            this.value = value ? parseInt(value, 10) : 1;
        });
    });
});

/* Search box special charcher restriction limit */

document.addEventListener("DOMContentLoaded", function () {
    const searchInputs = document.querySelectorAll(".search__input");

    searchInputs.forEach(input => {
        input.addEventListener("input", function () {
            // Remove special characters (allows only letters, numbers, and spaces)
            this.value = this.value.replace(/[^a-zA-Z0-9\s]/g, "");
        });
    });
});

/* Condition based on contact phone number */

document.addEventListener("DOMContentLoaded", function () {
    let phoneInput = document.getElementById("ContactForm-phone");

    phoneInput.addEventListener("input", function () {
        this.value = this.value.replace(/[^0-9+\-()]/g, ""); // Allow only numbers, +, -, ()
    });
});

/* Condition for the filter */

function  filterdatsrender(){
    let titleText = document.querySelector('.collection-hero__title')?.innerText.trim();
    titleText = titleText.replace(/\s+/g, " "); // Normalize spaces

    // Remove "Collection: " if it exists
    titleText = titleText.replace(/^Collection:\s*/, "");
    
    console.log('Title:', JSON.stringify(titleText)); // Debugging

    let section = document.querySelector("#Details-filter\\.p\\.m\\.custom\\.collection_category-template--24496733225333__product-grid");
    let items = section?.querySelectorAll("ul li"); // Get all list items

    if (!section || !items) return; // Stop if section or items are missing

    let count = items.length;
    console.log("Total Categories:", count);

    if (count === 1) {
        section.closest("details").style.display = "none";
        console.log("Hiding entire section due to only 1 item.");
    } else {
        items.forEach(li => {
            let input = li.querySelector("input[name='filter.p.m.custom.collection_category']");
            if (input) {
                let inputValue = input.value.trim().replace(/\s+/g, " "); // Normalize spaces
                console.log("Checking:", JSON.stringify(inputValue), "vs", JSON.stringify(titleText));

                if (inputValue === titleText) {
                    li.style.display = "none"; // Hide only matching element
                    console.log("Hiding item:", inputValue);
                }
            }
        });
    }

}
  

document.addEventListener("DOMContentLoaded", filterdatsrender);


/* On change */
document.addEventListener("change", () => {
    setTimeout(filterdatsrender, 2000);
});






